export enum UserDepartmentEnum {
    All = 1
}